import React, { useEffect, useState } from "react";
import { Avatar, Icon } from "rsuite";

const User = (props) => {
  const [userId, setUserId] = useState("");
  useEffect(() => {
    const userId = JSON.parse(sessionStorage.getItem("EmailID"));
    setUserId(userId);
  }, []);
  return (
    <div>
      <Avatar style={AvatarStyles} circle>
        <Icon icon="avatar" size="5x" />
      </Avatar>
      <h4 style={H4Style}>Email: {userId}</h4>
    </div>
  );
};

const AvatarStyles = {
  display: "flex",
  width: "55%",
  height: "20vh",
  margin: "auto",
  alignSelf: "center",
  justifyContent: "center",
  color: "white",
  backgroundColor: "#233975",
};

const H4Style = {
  margin: "10px",
  textAlign: "center",
  color: "white",
  fontSize: "15px",
};

export default User;
